// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2v3Mo","name":"Header_name__27BoI","birthday":"Header_birthday__Nk6uX","skeleton":"Header_skeleton__1Aqgy"};